import React from "react";

type EditMode = boolean;
export const EditModeContext = React.createContext<EditMode>(
  undefined as unknown as EditMode,
);
export function useEditMode() {
  return React.useContext(EditModeContext) ?? true;
}
